
import { AdminDashboardMetrics } from "./AdminDashboardMetrics";

export const AdminDashboard = () => {
  return (
    <div className="space-y-6 p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white">Dashboard</h2>
      </div>
      <AdminDashboardMetrics />
    </div>
  );
};
